// extracted by mini-css-extract-plugin
export default {"post":"post_post__WGsf8","blocksContainer":"post_blocksContainer__bLVY8","noBlocksMessage":"post_noBlocksMessage__WyWrl"};